import routes from "constants/routes";
import { Navigate, useLocation, useParams } from "react-router";
import { getUserStorage } from "util/local_storage";

/**
 * Component to handle the redirection logic based on query parameters and user state.
 * Redirects to different routes depending on the presence of `quotationId`, `qr_read`, and `user`.
 */
function ViewQuotationPdf() {
  const { search } = useLocation();
  const { quotationId } = useParams<{ quotationId: string }>();

  const params = new URLSearchParams(search);
  const qrRead = params.get("qr_read");
  const user = getUserStorage();
  const wheel = params.get("wheel");

  if (qrRead === "yes" && !user) {
    if (wheel === "yes") {
      return (
        <Navigate to={routes.mstWheelTireEstResultPdf.replace(":quoteId", quotationId || "")} />
      );
    }
    return <Navigate to={`/mst-car-model/${quotationId}/result-pdf`} />;
  }

  if (qrRead === "yes" && user) {
    return <Navigate to={routes.quotationDetail.replace(":quotationId", quotationId || "")} />;
  }
  return <Navigate to="/login" />;
}

export default ViewQuotationPdf;
